import angular from 'angular';

export default angular
  .module('csm.ui.maxCounter', [])

  /*******************************************************************************
   * Directive: maxCounter
   *
   * @ description
   * Provides a utility for viewing a number counter for a maximum value. When the
   * value exceeds the max value, the color will turn red. This component utilizes
   * two attributes to set the internal values. The values can be numeric text
   * or a string which will be evaluated against the scope to obtain the numeric
   * value to set.
   *
   * When either the max or value is NaN, it will be displayed as '--'.
   *
   * @attr {string} max   Maximum value/expression to check against
   * @attr {string} value Current value/expression
   *****************************************************************************/
  .directive('maxCounter', function ($document) {
    /** Invalid value class. */ var CLASS_INVALID = 'invalid';

    /*--------------------------------------------*/
    /* Add style block to handle an invalid value */
    /*--------------------------------------------*/
    var mBody = $document.find('body');
    mBody.append(
      angular.element(
        '<style>' +
          'max-counter           { padding: 5px }' +
          '.counterValue.invalid { color: red; font-weight: bold }' +
          '</style>'
      )
    );

    return {
      restrict: 'E',
      template:
        '<span class="counterValue"></span> / <span class="counterMax"></span>',
      scope: true,
      link: function (scope, element, attrs) {
        /*************************************************************************
         * Properties
         *************************************************************************/
        /*-----------------*/
        /* Numeric Values. */
        /*-----------------*/
        var mMax = NaN,
          mValue = NaN;

        /*---------------*/
        /* Span Elements */
        /*---------------*/
        var mMaxSpan = angular.element(
          element[0].querySelector('span.counterMax')
        );
        var mValueSpan = angular.element(
          element[0].querySelector('span.counterValue')
        );

        /*************************************************************************
         * checkValue */
        /**
         * Checks the value is not greater than the max. Sets/clears the invalid
         * indicator accordingly.
         *************************************************************************/
        function checkValue() {
          var isInvalid = mValue > mMax;

          if (isInvalid) mValueSpan.addClass(CLASS_INVALID);
          else mValueSpan.removeClass(CLASS_INVALID);
        }

        /*************************************************************************
         * getText */
        /**
         * Returns text to display for the numeric input. When Nan, '--' is shown.
         *************************************************************************/
        function getText(input) {
          return isNaN(input) ? '--' : input.toString();
        }

        /*************************************************************************
         * parseNumberFromAttribute */
        /**
         * Attempts to read the provided attribute from the element. If the value
         * doesn't evaluate to be a number, then it is assumed to be an expression
         * and is evaluated against the scope before being converted to a number.
         *
         * @param  attr  Attribute name to check
         * @return       Parsed number from attribute value
         *************************************************************************/
        function parseNumberFromAttribute(attr) {
          var attrValue = element.attr(attr);

          /*-------------------------*/
          /* Check for numeric value */
          /*-------------------------*/
          var num = Number(attrValue);
          if (!isNaN(num)) return num;

          /*----------------------------------------------------------*/
          /* Value is not numeric, assume scope property and evaluate */
          /*----------------------------------------------------------*/
          return Number(scope.$eval(attrValue));
        }

        /*------------------------------------*/
        /* Watch for changes to the max value */
        /*------------------------------------*/
        scope.$watch(
          function () {
            return parseNumberFromAttribute('max');
          },
          function (max) {
            mMaxSpan.text(getText((mMax = max)));
            checkValue();
          }
        );

        /*--------------------------------*/
        /* Watch for changes to the value */
        /*--------------------------------*/
        scope.$watch(
          function () {
            return parseNumberFromAttribute('value');
          },
          function (value) {
            mValueSpan.text(getText((mValue = value)));
            checkValue();
          }
        );
      }
    };
  }).name;
